export const sss = {
  首页: '首页',
}
